import React, { Component, PropTypes } from 'react';
import moment from 'moment';
import truncate from 'lodash/truncate';
import classnames from 'classnames';
import Money from 'common/components/money';
import ProjectLink from 'common/containers/project_link';
import Thumbnail from 'common/components/thumbnail';
import StarRating from 'common/components/star_rating';
import RevisionDisclosures from 'entries/containers/revision_disclosures';
import Menu from 'admin/containers/project_entries/actions_menu';

export default class ImageNameTile extends Component {
  renderThumbnail() {
    const { item, entryType } = this.props;
    const revision = item.revisions[0];
    const thumbClasses = classnames('tile entry-thumbnail', {
      withdrawn: item.withdrawn,
      stacked: item.revisions.length > 1,
    });

    return (
      <Thumbnail className={thumbClasses} image={entryType === 'name'? null : revision.thumbnails[0]}>

        { entryType === "name" && <div className="revision-name">{ revision.name }</div> }

        { (item.withdrawn || item.eliminated) &&
        <div className={classnames("flag info", { "extended": item.withdrawn && item.eliminated })}>
          <div>
            { item.withdrawn && <span>withdrawn</span> }
            { item.withdrawn && item.eliminated && <br/> }
            { item.eliminated && <span>eliminated</span> }
          </div>
        </div> }

        { item.winner &&
        <div className="flag winner with-value">
          <div>
            <span>Winner</span>
            <Money className="value" value={item.award_value} />
          </div>
        </div> }

        { item.runnerup && !item.winner &&
        <div className="flag winner with-value">
          <div>
            <span>Finalist</span>
            <Money className="value" value={item.award_value} />
          </div>
        </div> }

        { !!parseFloat(item.tip_value) &&
        <div className="flag tipped with-value">
          <div>
            <span>Tipped</span>
            <Money className="value" value={item.tip_value} />
          </div>
        </div> }

        { !!parseFloat(item.offer_value) &&
        <div className="flag tipped with-value">
          <div>
            <span>Offered</span>
            <Money className="value" value={item.offer_value} />
          </div>
        </div> }
      </Thumbnail>
    );
  }

  render() {
    const { item, grouped, viewType } = this.props;
    const revision = item.revisions[0];
    const project = {
      id: item.project,
      slug: item.project_slug,
      sub_category: item.project_sub_category,
      title: item.project_title
    };

    return (
      <div className="column column-block entry">
        <div className="entry-tile">
          <div className="tile-left">
            <ProjectLink project={project} append={`entry/${item.id}/`} target="_blank">
              { this.renderThumbnail() }
            </ProjectLink>

            <StarRating key={item.id} readonly={true} initialRate={revision.score || 0}
              extraClasses="lg" />
          </div>
          <div className="tile-right">
            <p className="revision-author">
              <span className="entry-number">
                #{ grouped ? item.entry_number : revision.revision_number }
              </span> on {' '}
              <ProjectLink project={project} append="your-entries/" target="_blank">
                { truncate(project.title, { length: 20 }) }
              </ProjectLink> {' '}
              <span className="revision-time">{ moment(revision.created_at).fromNow() }</span>
            </p>
            { viewType === "list" &&
            <div className="revision-description">
              <h4>Description:</h4>
              <p>{ revision.description }</p>
            </div> }
            { viewType === "list" &&
            <RevisionDisclosures entry={item} revision={revision} canViewAssetPrice={true} /> }
          </div>
          <div className="clearfix" />
        </div>
      </div>
    );
  }
}

ImageNameTile.propTypes = {
  item: PropTypes.object.isRequired,
  viewType: PropTypes.string.isRequired,
  entryType: PropTypes.string.isRequired,
  grouped: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./profile/components/your_entries/image_name_tile.jsx